/**
 * 调 Nexora 身份桥：用现有 JWT 换 OpenIM 连接参数（bootstrap）。
 *
 * 边界：这是 IM 域唯一打 Nexora 后端的入口之一（另一个是目录搜人）；
 * 之后的聊天数据面全部由 OpenIM WASM SDK 直连，不再经过 Nexora。
 */
import { authHeaders } from "../../auth/token";
import { getApiBase } from "../../api/client";
import type { ImBootstrap } from "../types";

/**
 * POST /api/im/bootstrap：换取 OpenIM 登录四元组等。
 * 返回：ImBootstrap（im_user_id / im_token / api_addr / ws_addr / ...）。
 * 失败：抛 Error（含 HTTP 状态码与后端响应文本）。
 */
export async function fetchImBootstrap(): Promise<ImBootstrap> {
    const base = getApiBase(); // 与现有前端一致 
    const resp = await fetch(`${base}/api/im/bootstrap`,{
        method: "POST",
        headers: {
            "Content-Type":"application/json",
            ...authHeaders(),
        },
    });
    if (!resp.ok) {
       const text = await resp.text();
       throw new Error(`IM bootstrap 失败 HTTP ${resp.status}: ${text}`);
    }
    return (await resp.json()) as ImBootstrap;
}